import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MessageIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM6.36 7.02L12 11.68L17.64 7.02H6.36ZM18.54 16.7V8.38L12 13.76L5.46 8.38V16.7H18.54Z" />
    </SvgIcon>
  );
});
